import { Phone, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
export default function AnneArundelHero() {
  const schemaData = {
    "@context": "https://schema.org",
    "@graph": [{
      "@type": "HomeAndConstructionBusiness",
      "name": "TriServe",
      "telephone": "855-435-6631",
      "areaServed": "Anne Arundel County, MD",
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Emergency Restoration Services",
        "itemListElement": [{
          "@type": "Service",
          "name": "Water Damage & Flood Restoration"
        }, {
          "@type": "Service",
          "name": "Sewage Backup Cleanup"
        }, {
          "@type": "Service",
          "name": "Fire & Smoke Damage Restoration"
        }, {
          "@type": "Service",
          "name": "Mold Remediation"
        }]
      }
    }, {
      "@type": "BreadcrumbList",
      "itemListElement": [{
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://triserveinc.com/"
      }, {
        "@type": "ListItem",
        "position": 2,
        "name": "Maryland",
        "item": "https://triserveinc.com/MarylandPage"
      }, {
        "@type": "ListItem",
        "position": 3,
        "name": "Anne Arundel County"
      }]
    }]
  };
  return <section id="annearundelhero" data-nav="light" className="relative bg-background text-foreground py-12 md:py-20 lg:py-24 border-b border-border">
      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(schemaData)
    }} />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl">
        <div className="mb-6 sm:mb-8">
          <Breadcrumb>
            <BreadcrumbList>
              <BreadcrumbItem>
                <BreadcrumbLink asChild>
                  <Link to="/">Home</Link>
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbLink asChild>
                  <Link to="/MarylandPage">Maryland</Link>
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbPage>Anne Arundel County</BreadcrumbPage>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>
        </div>

        <div className="space-y-6">
          <h1 className="font-default text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-foreground leading-[1.15]">
            Anne Arundel County Disaster & Restoration Services
          </h1>

          <p className="max-w-3xl text-lg sm:text-xl text-muted-foreground leading-relaxed">
            24/7 rapid emergency mitigation for Anne Arundel County homeowners
            and commercial facilities. Our direct local crews respond quickly to
            waterfront tidal flooding, Chesapeake Bay storm surges, pipe
            ruptures, sewage emergencies, and mold hazards.
          </p>

          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-4 pt-2">
            <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 h-12 px-6 text-base font-semibold shadow-sm">
              <a href="tel:8554356631">
                <Phone className="size-5 shrink-0" aria-hidden="true" />
                <span>Call Now: 855-435-6631</span>
              </a>
            </Button>

            <Button asChild variant="outline" size="lg" className="border-border text-foreground hover:bg-muted h-12 px-6 text-base font-semibold shadow-xs">
              <Link to="/ContactRequestServicePage">
                <span>Request Service</span>
                <ArrowRight className="size-4 shrink-0" aria-hidden="true" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}